var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"wrapper"},[(_vm.error == false)?_c('p',[_vm._v("SUCCESS!")]):_vm._e(),(_vm.error == true)?_c('p',[_vm._v("ERROR!")]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }